import { PointsExceptionError } from '@kudos/http-client'
import FormSubmissionExceptions from '@tenant/recognition/RecognitionModal/sendRecognitionView/formSubmissionExceptions/FormSubmissionExceptions'
import { MOBILE_RECOGNITION_FORM_ID } from '.'

type MobileRecognitionPointsExceptionViewProps = {
  pointsExceptions?: PointsExceptionError
}

const MobileRecognitionPointsExceptionView: React.FC<MobileRecognitionPointsExceptionViewProps> = ({
  pointsExceptions,
}) => {
  return (
    <FormSubmissionExceptions
      pointsExceptions={pointsExceptions}
      formId={MOBILE_RECOGNITION_FORM_ID}
    />
  )
}

export default MobileRecognitionPointsExceptionView
